module.exports = __webpack_public_path__ + "b966c373e9e21f3edf05dcd10a7479f8.woff2";